export const SESSION_EXPIRED_EVENT = 'emailveritas:session-expired';

export function notifySessionExpired(response, requestToken) {
  if (response.status !== 401 || !requestToken) return;
  // A delayed rejection from an older session must not log out a new login.
  if (sessionStorage.getItem('eVeritasToken') !== requestToken) return;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
}
